export enum ParcelProductTypeEnum {
  BOTTLE = "BOTTLE",
  OTHER = "OTHER",
}
